import { render, staticRenderFns } from "./DocActionsMenu.vue?vue&type=template&id=239b6dae"
import script from "./DocActionsMenu.vue?vue&type=script&lang=js"
export * from "./DocActionsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports